import FinancialStatementsPage from 'screens/FinancialStatements/FinancialStatements';

export default FinancialStatementsPage;
